import { FC } from 'react'

import styles from '@/screens/Sitemap/Sitemap.module.scss'
import { LinkItem } from '@/screens/Sitemap/ui'
import { LinkItemType } from '@/screens/Sitemap/ui/LinkItem/LinkItem'

interface SectionProps {
	title: string
	items: LinkItemType[]
	renderLink?: (item: any, index: number) => string
	expandable?: boolean
}

export const Section: FC<SectionProps> = ({ title, items, renderLink }) => {
	return (
		<section className={styles.section}>
			<h2 className={styles.sectionTitle}>{title}</h2>
			<ul className={styles.list}>
				{items.map((item, index) => (
					<LinkItem
						key={index}
						item={{
							title: item.title,
							path: renderLink ? renderLink(item, index) : item.path,
							children: item.children
						}}
						level={1}
					/>
				))}
			</ul>
		</section>
	)
}
